import { FaSearch, FaSignOutAlt } from "react-icons/fa";
import styles from "./styles.module.css";
import { Avatar } from "../Avatar";

const Header = ({ user, title }: any) => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>{title}</div>
      <div className={styles.search}>
        <FaSearch /> <input type="text" />
      </div>
      <div className={styles.user}>
        <div className={styles.dp}>
          {user.photo ? (
            <img src={`${user?.photo}`} alt="dp" />
          ) : (
            <img src={Avatar(user?.gender)} alt="dp" />
          )}
        </div>

        {user?.fullname}
        <FaSignOutAlt />
      </div>
    </div>
  );
};

export default Header;
